export default __webpack_public_path__ + "static/media/Newsletter 017.a5dd82f9.png";